import config from "../config.js";
import RequestManager from "./request.js";

export default class Assertion {


    static setAssertionPS(Assertion) {
        const urlSetAssertionVitaleAndPS = `${config.urlBackEnd}Assertion/setAssertionPS`;
        return RequestManager.post(urlSetAssertionVitaleAndPS, Assertion);
    }

    static setAssertionVitaleAndPS(dicAssertion) {
        const urlSetAssertionVitaleAndPS = `${config.urlBackEnd}Assertion/setAssertionVitaleAndPS`;
        return RequestManager.post(urlSetAssertionVitaleAndPS, dicAssertion);
    }

    static generateAdrResponseAndImtResponse(indexBenef) {
        const urlGenerateAdrResponseAndImtResponse = `${config.urlBackEnd}Assertion/GenerateAdrResponseAndImtResponse/${indexBenef}`;
        return RequestManager.post(urlGenerateAdrResponseAndImtResponse, {});
    }

    // Declenche l'IMT (Interrogation Medecin Traitant) pour un beneficiaire donne (re-interrogation
    // manuelle, ou flux Vitale isole). L'appel s'execute cote lib sur un thread de fond -> relire
    // ensuite le resultat via getReponseIMT (polling).
    static generateImtResponse(indexBenef) {
        const url = `${config.urlBackEnd}Assertion/GenerateImtResponse/${indexBenef}`;
        return RequestManager.post(url, {});
    }

    // Relit le resultat IMT courant (medecin traitant + statut d'execution). Cible de polling :
    // le front rappelle jusqu'a un statut d'execution terminal (!= EnCoursDExecution).
    static async getReponseIMT() {
        try {
            const url = `${config.urlBackEnd}Assertion/GetReponseIMT/`;
            return await RequestManager.get(url);
        } catch (error) {
            console.error("Erreur dans getReponseIMT:", error);
            throw error;
        }
    }
    static async getDonneeResponseADR() {
        try {
            const urlGetResponseADR = `${config.urlBackEnd}Assertion/GetDonneeResponseADR/`;
            const response = await RequestManager.get(urlGetResponseADR);
            return response;
        } catch (error) {
            console.error("Erreur dans getDonneeResponseADR:", error);
            throw error;
        }
    }

    // Statut + message d'erreur de la derniere reponse ADR (Vitale ou degrade), pour le panneau ADR.
    static async getStatutADR() {
        try {
            const url = `${config.urlBackEnd}Assertion/GetStatutADR/`;
            return await RequestManager.get(url);
        } catch (error) {
            console.error("Erreur dans getStatutADR:", error);
            throw error;
        }
    }

    static generateApcvResponse(tokenAPCV) {
        const urlGenerateApcvResponse = `${config.urlBackEnd}Assertion/GenerateApcvResponse`;
        return RequestManager.post(urlGenerateApcvResponse, tokenAPCV);
    }

    static getParametersForComminInit() {
        var url = `${config.urlBackEnd}Assertion/getParametersForComminInit`;
        alert("dans Assertion.getParametersForComminInit")
        RequestManager.post(url, {})
            .then(response => {
                console.log(response);
                RequestManager.EnvoyerMessageWebView({ action: "loadXML", parameters: response });
            })
    }
}
